import { render, staticRenderFns } from "./TheEnkryptPopup.vue?vue&type=template&id=07c4b974&scoped=true"
import script from "./TheEnkryptPopup.vue?vue&type=script&lang=js"
export * from "./TheEnkryptPopup.vue?vue&type=script&lang=js"
import style0 from "./TheEnkryptPopup.vue?vue&type=style&index=0&id=07c4b974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c4b974",
  null
  
)

export default component.exports